export default __webpack_public_path__ + "static/media/haryanalogo.40364195.png";